import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TableRequirement } from "./../../../domains/RequirementList/TableRequirement";

const SLICE_NAME = "requirementsList";

type SelectedStatus = {
  all: boolean
  planningAndScheduling: boolean
  processEngineering: boolean
  concluded: boolean
  feedStockTrading: boolean
}

export interface RequirementListState {
  requirements: Array<TableRequirement>
  isLoading: boolean
  hasError: boolean
  selectedStatus: SelectedStatus
  pageIndex: number
  pageSize: number
  amountOfRequirements: number
  filterParams: string
}

export const initialState: RequirementListState = {
  requirements: [],
  isLoading: false,
  hasError: false,
  selectedStatus: {
    all: true,
    planningAndScheduling: false,
    processEngineering: false,
    concluded: false,
    feedStockTrading: false,
  } as SelectedStatus,
  pageIndex: 0,
  pageSize: 10,
  amountOfRequirements: 0,
  filterParams: ""
};

export const requirementListSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getRequirements: state => {
      state.isLoading = true;
    },
    getRequirementsSuccess: (state, action: PayloadAction<TableRequirement[]>) => {
      state.isLoading = false;
      state.requirements = [...action.payload];
    },
    getRequirementsError: state => {
      (state.isLoading = false), (state.hasError = true);
    },
    setFilterParams: (state, action: PayloadAction<string>) => {
      state.filterParams = action.payload;
    },
    changePage: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setTotalAmountOfRequirementsByFilter: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.amountOfRequirements = action.payload;
    }
  },
});

export const {
  getRequirements,
  getRequirementsSuccess,
  getRequirementsError,
  setFilterParams,
  setTotalAmountOfRequirementsByFilter,
  changePage
} = requirementListSlice.actions;

export default requirementListSlice.reducer;
